import { atom } from "recoil";
import { ocPersistAtom } from "./persist-atom";

export const ocAddPermissionEmailState = atom({
  key: "ocAddPermissionEmailState",
  default: {
    value: "",
    error: false,
    errorText: "",
    label: "MY_HR_EMAIL",
  },
  effects_UNSTABLE: [ocPersistAtom],
});
